// Import core video.js library and CSS
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

// Import all required plugins.
// Note that just importing some plugins (like seek-buttons) is enough to register them.
import 'videojs-contrib-quality-levels';
import hlsQualitySelector from 'videojs-hls-quality-selector';
import "videojs-seek-buttons";
import offset from 'videojs-offset';
import 'videojs-vr/dist/videojs-vr.min.js';

// A separate import for the VR plugin's stylesheet
import 'videojs-vr/dist/videojs-vr.css';

videojs.registerPlugin("offset", offset);
videojs.registerPlugin("hlsQualitySelector", hlsQualitySelector);

// 閲覧時間を計算します
function calc_viewing_time(timer) {
  var total_time = 0;
  if (timer.getTimeValues().hours > 0) {
    total_time += timer.getTimeValues().hours * 3600
  }
  if (timer.getTimeValues().minutes > 0) {
    total_time += timer.getTimeValues().minutes * 60
  }
  if (timer.getTimeValues().seconds > 0) {
    total_time += timer.getTimeValues().seconds
  }
  return total_time;
}

// ビデオ設定を生成します
// param: iOSかどうか
function createVideoSettings(_isiOS) {
  const video_settings = {
    "textTrackSettings": false,
    "fluid": true,
    "playsinline": _isiOS, // iOSではネイティブプレイヤー抑制のため全画面表示させない
    "playbackRates": [0.75, 1, 1.25, 1.5, 2],
    controlBar: {
      children: [
        "playToggle",
        "volumePanel",
        'progressControl',
        'placeholderButton',
        "currentTimeDisplay",
        "timeDivider",
        "durationDisplay",
        "qualitySelector",
        "playbackRateMenuButton",
        "captionsButton",
        "fullscreenToggle"
      ],
      volumePanel: {inline: false},
    },
  };
  return video_settings
}


// ライブ配信用ビデオ設定を生成します
function createLiveVideoSettings() {
  const video_settings = {
    fluid: true,
    controlBar: {
      playToggle: true,
      volumePanel: {inline: false},
      liveDisplay: true,
      progressControl: true,
      qualitySelector: true,
      fullscreenToggle: true,
      subtitlesButton: true
    },
  };
  return video_settings
}

window.videojs = videojs;
window.calc_viewing_time = calc_viewing_time;
window.createVideoSettings = createVideoSettings;
window.createLiveVideoSettings = createLiveVideoSettings;
